import type { MeContext, PortfolioNode, WorkspaceNode } from '@vizit/api';

// The subtree is already grant-filtered by the BE.
export function getAccessiblePortfolios(context: MeContext): PortfolioNode[] {
  return context.organization.portfolios;
}

export function getAccessibleWorkspaces(context: MeContext): WorkspaceNode[] {
  return context.organization.portfolios.flatMap((portfolio) => portfolio.workspaces);
}
